import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SupportOutageAlert } from './support-outage-banner.interface';

@Injectable({
    providedIn: 'root',
})
export class SupportOutageBannerService {
    private http = inject(HttpClient);

    private bannerHeightSubject = new BehaviorSubject<number>(0);
    bannerHeight$ = this.bannerHeightSubject.asObservable();

    get supportOutageAlert$(): Observable<SupportOutageAlert> {
        return this.http.get<SupportOutageAlert>('https://status.mypurecloud.com/api/v2/summary.json');
    }

    setBannerHeight(height: number): void {
        this.bannerHeightSubject.next(height);
    }
}
